import { DateTime } from 'luxon';

import { categoriesSelectors } from 'app-components/flux/categories';
import store from 'app-components/utils/redux-store';

import { accountsSelectors } from 'app-components/flux/accounts';
import * as transactionsTypes from 'app-components/flux/transactions/transactionsTypes';

const allTaxLineItemsTransactions = () => {
  let resources;
  if (store) {
    const categories = categoriesSelectors.getResourcesById(store.getState());
    const taxLineItemsCategories = categories.filter((category) => category.txfId);
    const accountId = accountsSelectors.getBankAccounts(store.getState()).first()?.id;
    resources = taxLineItemsCategories.toIndexedSeq().reduce(
      (transactions, taxLineItemCategory, index) => [
        ...transactions,
        transactionsTypes.mkCashFlowTransaction({
          accountId,
          coa: { type: 'CATEGORY', id: taxLineItemCategory.id || '' },
          postedOn: DateTime.now().toISODate(),
          payee: taxLineItemCategory.txfId,
          amount: index + 1,
          state: 'CLEARED',
        }),
      ],
      [],
    );
  }
  return { resources };
};
``;
export default allTaxLineItemsTransactions;
